import {Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'app-x-label-padding',
  standalone: true,
  imports: [],
  templateUrl: './x-label-padding.component.html',
  styleUrl: './x-label-padding.component.less'
})
export class XLabelPaddingComponent {
  @HostBinding('class') @Input() orientation: 'vertical' | 'horizontal' | 'both' | 'none' = 'horizontal';
  @HostBinding('style.color') @Input() color = 'rgba(0, 0, 0, 0.80)'
}
